'use strict';

import modalDirective from '../../rest-modal';

import template from './template.html';

export default modalDirective({
	template: template,
});
